import { render, staticRenderFns } from "./SelectAllColumn.vue?vue&type=template&id=533cac64&"
import script from "./SelectAllColumn.vue?vue&type=script&lang=ts&"
export * from "./SelectAllColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports